<script setup lang="ts">
    import ConsistencyAnalysisCircles from '@Evaluation/Common/Components/ConsistencyAnalysisCircles.vue'
</script>


<template>
    <div>
        <table class="table">
            <tbody>
                <tr>
                    <td class="align-middle">
                        <ConsistencyAnalysisCircles :status="'Inconsistent'"></ConsistencyAnalysisCircles>
                    </td>
                    <td>
                        <strong>Inconsistency score: above 20%</strong><br />
                        Your answers are inconsistent.
                        We recommend you go back and revisit the questions that are contributing most to your inconsistency score.
                        The software will highlight the key questions for you.
                    </td>
                </tr>
                <tr>
                    <td class="align-middle">
                        <ConsistencyAnalysisCircles :status="'Acceptable'"></ConsistencyAnalysisCircles>
                    </td>
                    <td>
                        <strong>Inconsistency score: 10-20%</strong><br />
                        Your inconsistency is a little higher than it should be. If your decision involves lots of "highly subjective" issues,
                        this level of inconsistency might be okay - to be human is to be inconsistent!
                        If your decision is mostly driven by "hard numbers", your consistency should be lower - you may want to go back and review your answers to key questions.
                    </td>
                </tr>
                <tr>
                    <td class="align-middle">
                        <ConsistencyAnalysisCircles :status="'Consistent'"></ConsistencyAnalysisCircles>
                    </td>
                    <td>
                        <strong>Inconsistency score: below 10%</strong><br />
                        Great job! The consistency of your answers is good!
                    </td>
                </tr>
                <tr>
                    <td class="align-middle">
                        <ConsistencyAnalysisCircles :status="'Unknown'"></ConsistencyAnalysisCircles>
                    </td>
                    <td>
                        <strong>Inconsistency score: Unknown</strong><br />
                        Not enough data to calculate it.
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
</style>